/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InternshipApplication } from '../../models/internship-application';

export interface UpdateInternshipApplication$Params {
  id: string;
      body?: InternshipApplication
}

export function updateInternshipApplication(http: HttpClient, rootUrl: string, params: UpdateInternshipApplication$Params, context?: HttpContext): Observable<StrictHttpResponse<InternshipApplication>> {
  const rb = new RequestBuilder(rootUrl, updateInternshipApplication.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InternshipApplication>;
    })
  );
}

updateInternshipApplication.PATH = '/internshipapplications/{id}';
